import {useState,useEffect,useRef} from 'react';
import {authservices} from '../../services/authServices';
import {userservices} from '../../services/userServices';
import {clientservices} from '../../services/clientservices';
import { Toast } from 'primereact/toast';
import { Backbuttons } from '../../components/buttons';
import  Bredcrum  from '../../components/bredcrum';
import { Tag } from 'primereact/tag';
import {Label} from '../../components/fieldsComp';
const Basicdetails = () =>{

    const [initaildetails,setDetails] = useState();
    const toast = useRef(null);
    const handleChanges = (e) =>{
        setDetails((prevData)=>{
              return {
                ...prevData,
                [e.target.name]:e.target.value
              }
        });    
    }

    const updatebasicdetails = () =>{
        console.log("insiatil values"); 
        console.log(initaildetails);
    }

    return(<>
        <Toast ref={toast} /> 
        <Bredcrum title={'Basic Details'}/>
         <div className="card">
         <div className="card-body">
         <form onSubmit={(e)=>updatebasicdetails(e)}>
          <div class="row">
              <div className="col-md-3 p-0"> 
               <div class="form-group">
                  <Label name={'First Name'}/>
                  {/* <label for="name">First Name</label> */}
                  <input
                      type="text"
                      class="form-control"
                      id="name"
                      name="name"
                      placeholder="Enter First name"
                      onChange={handleChanges}
                  />
               </div>
              </div>

              <div className="col-md-3 p-0"> 
               <div class="form-group">
                  <Label name={'Last Name'}/>
                  {/* <label for="name">Last Name</label> */}
                  <input
                      type="text"
                      class="form-control"
                      id="name"
                      name="name"
                      placeholder="Enter Last name"
                      onChange={handleChanges}
                  />
               </div>
              </div>

              <div className="col-md-3 p-0"> 
               <div class="form-group">
                  {/* <label for="name">Email Address</label> */}
                  <Label name={'Email Address'}/>
                  <input
                      type="email"
                      class="form-control"
                      id="name"
                      name="email"
                      placeholder="Enter Email Address"
                      onChange={handleChanges}
                  />
               </div>
              </div>

              <div className="col-md-3 p-0"> 
               <div class="form-group">
                  {/* <label for="name">Mobile No</label> */}
                  <Label name={'Mobile No'}/>
                  <input
                      type="number"
                      class="form-control"
                      id="name"
                      name="name"
                      placeholder="Enter Mobile no"
                      onChange={handleChanges}
                  />
               </div>
              </div>
              
              <div className="col-md-3"> 
                  <div class="form-group">
                      <label for="email2">Select Roles</label>
                      <select className="form-control" required name="roles" onChange={handleChanges}>
                          <option value="employee">Employee</option>
                          <option value="manager">Manager</option>
                      </select>
                  </div>
              </div>

              <div className="col-md-3">
                 <div style={{marginTop:'26px'}}></div> 
                 <div class="form-group">
                    <button className="btn btn-success-custom" type="submit">Save</button>
                 </div>
              </div>
             </div>
           </form>
          </div>
        </div>
   </>);   
}

export default Basicdetails;